import { jsx as c, jsxs as I } from "react/jsx-runtime";
import { Children as N, cloneElement as A } from "react";
function E(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var S = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var j;
function P() {
  return j || (j = 1, function(e) {
    (function() {
      var u = {}.hasOwnProperty;
      function n() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var s = arguments[t];
          s && (r = i(r, a.call(this, s)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var s in r)
          u.call(r, s) && r[s] && (t = i(t, this && this[s] || s));
        return t;
      }
      function i(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(S)), S.exports;
}
var Z = P();
const k = /* @__PURE__ */ E(Z), T = {
  "purpur-icon": "_purpur-icon_8u1lq_1",
  "purpur-icon--xxs": "_purpur-icon--xxs_8u1lq_4",
  "purpur-icon--xs": "_purpur-icon--xs_8u1lq_8",
  "purpur-icon--sm": "_purpur-icon--sm_8u1lq_12",
  "purpur-icon--md": "_purpur-icon--md_8u1lq_16",
  "purpur-icon--lg": "_purpur-icon--lg_8u1lq_20",
  "purpur-icon--xl": "_purpur-icon--xl_8u1lq_24"
}, D = k.bind(T), z = "purpur-icon", F = "md", J = (e) => e.filter((u) => Object.keys(u).length >= 1).map((u) => `${u.name}="${u.value}"`).join(" "), R = ({ content: e = "", title: u } = {}) => {
  const n = [
    { name: "xmlns", value: "http://www.w3.org/2000/svg" },
    { name: "fill", value: "currentColor" },
    { name: "viewBox", value: "0 0 24 24" },
    u ? { name: "role", value: "img" } : { name: "aria-hidden", value: "true" }
  ], a = u ? `<title>${u}</title>` : "";
  return `<svg ${J(n)}>${a}${e}</svg>`;
}, V = (e) => e.replace(/<(\/?)svg([^>]*)>/g, "").trim(), q = ({
  ["data-testid"]: e,
  svg: u,
  allyTitle: n,
  className: a,
  size: i = F,
  ...r
}) => {
  const t = R({
    content: V(u.svg),
    title: n
  }), s = D(a, z, `${z}--${i}`);
  return /* @__PURE__ */ c(
    "span",
    {
      className: s,
      "data-testid": e,
      dangerouslySetInnerHTML: { __html: t },
      ...r
    }
  );
};
q.displayName = "Icon";
const G = {
  name: "home",
  svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path fill-rule="evenodd" d="M11.38 1.848a.9.9 0 0 1 1.24 0l8.69 8.276c1.242 1.183.405 3.276-1.31 3.276h-.6v8.1a.9.9 0 0 1-.9.9h-13a.9.9 0 0 1-.9-.9v-8.1H4c-1.715 0-2.552-2.093-1.31-3.276l8.69-8.276ZM12 3.743l-8.069 7.685c-.026.024-.03.04-.032.049a.11.11 0 0 0 .008.06.11.11 0 0 0 .036.049c.007.005.021.014.057.014h1.5a.9.9 0 0 1 .9.9v8.1h11.2v-8.1a.9.9 0 0 1 .9-.9H20c.036 0 .05-.009.057-.014a.111.111 0 0 0 .036-.049.111.111 0 0 0 .008-.06c-.002-.008-.006-.025-.032-.05L12 3.744ZM10.6 14a.9.9 0 0 1 .9-.9H15a.9.9 0 0 1 .9.9v4a.9.9 0 0 1-.9.9h-3.5a.9.9 0 0 1-.9-.9v-4Zm1.8.9v2.2h1.7v-2.2h-1.7Z" clip-rule="evenodd"/></svg>',
  keywords: ["home"],
  category: "buildings"
}, L = (e) => /* @__PURE__ */ c(q, { ...e, svg: G });
L.displayName = "IconHome";
function K(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var v = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var O;
function Q() {
  return O || (O = 1, function(e) {
    (function() {
      var u = {}.hasOwnProperty;
      function n() {
        for (var r = "", t = 0; t < arguments.length; t++) {
          var s = arguments[t];
          s && (r = i(r, a.call(this, s)));
        }
        return r;
      }
      function a(r) {
        if (typeof r == "string" || typeof r == "number")
          return this && this[r] || r;
        if (typeof r != "object")
          return "";
        if (Array.isArray(r))
          return n.apply(this, r);
        if (r.toString !== Object.prototype.toString && !r.toString.toString().includes("[native code]"))
          return r.toString();
        var t = "";
        for (var s in r)
          u.call(r, s) && r[s] && (t = i(t, this && this[s] || s));
        return t;
      }
      function i(r, t) {
        return t ? r ? r + " " + t : r + t : r;
      }
      e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
    })();
  }(v)), v.exports;
}
var U = Q();
const W = /* @__PURE__ */ K(U), m = {
  "purpur-breadcrumbs": "_purpur-breadcrumbs_13trz_1",
  "purpur-breadcrumbs__list": "_purpur-breadcrumbs__list_13trz_4",
  "purpur-breadcrumb-item": "_purpur-breadcrumb-item_13trz_14",
  "purpur-breadcrumb-item__element": "_purpur-breadcrumb-item__element_13trz_19",
  "purpur-breadcrumb-item__link": "_purpur-breadcrumb-item__link_13trz_28",
  "purpur-breadcrumb-item--default": "_purpur-breadcrumb-item--default_13trz_32",
  "purpur-breadcrumb-item--negative": "_purpur-breadcrumb-item--negative_13trz_46",
  "purpur-breadcrumb-item--current": "_purpur-breadcrumb-item--current_13trz_60",
  "purpur-breadcrumb-item__home": "_purpur-breadcrumb-item__home_13trz_93"
}, X = (e, u, n) => {
  const a = {
    "@type": "ListItem",
    position: u,
    name: e
  };
  return n && (a.item = n), a;
}, Y = (e) => JSON.stringify({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: e
}), p = W.bind(m), g = "purpur-breadcrumbs", o = "purpur-breadcrumb-item", rr = ({
  ["aria-label"]: e,
  baseUrl: u,
  children: n,
  className: a,
  linkElement: i = "a",
  meta: r = !0,
  negative: t = !1,
  highlightLast: s = !0,
  hideHomeIcon: d,
  ..._
}) => {
  const f = p([
    a,
    g,
    `${g}--${t ? "negative" : "default"}`
  ]), l = N.count(n), b = [], B = N.map(n, (x, M) => {
    const h = M + 1, $ = l === h, H = s && $, { children: C, href: w } = x.props;
    return b.push(X(C, h, w && `${u}${w}`)), A(x, {
      current: H,
      negative: t,
      first: !d && h === 1,
      last: $,
      linkElement: i
    });
  }), y = b.length === l ? Y(b) : null;
  return /* @__PURE__ */ I("nav", { "aria-label": e, className: f, ..._, children: [
    /* @__PURE__ */ c("ol", { className: m[`${g}__list`], children: B }),
    r && y ? /* @__PURE__ */ c(
      "script",
      {
        type: "application/ld+json",
        "data-testid": "breadcrumbs-meta",
        dangerouslySetInnerHTML: { __html: y }
      }
    ) : null
  ] });
}, er = ({
  href: e,
  ["data-testid"]: u,
  children: n,
  current: a = !1,
  linkElement: i = "a",
  negative: r = !1,
  onClick: t,
  first: s = !1,
  last: d = !1,
  ..._
}) => {
  const f = i, l = p(
    [o],
    m[`${o}--${r ? "negative" : "default"}`],
    {
      [`${o}--current`]: a
    }
  );
  return /* @__PURE__ */ c("li", { ..._, className: l, children: d ? /* @__PURE__ */ c(
    "span",
    {
      "aria-current": "page",
      "data-testid": u,
      className: p(`${o}__element`),
      children: n
    }
  ) : /* @__PURE__ */ I(
    f,
    {
      href: e,
      "data-testid": u,
      onClick: t,
      className: p(`${o}__element`, `${o}__link`),
      children: [
        s && /* @__PURE__ */ c("span", { className: m[`${o}__home`], "aria-hidden": "true", children: /* @__PURE__ */ c(L, { size: "xs" }) }),
        n
      ]
    }
  ) });
};
rr.Item = er;
export {
  rr as Breadcrumbs,
  er as BreadcrumbsItem
};
//# sourceMappingURL=breadcrumbs.es.js.map
